import { ca } from '@cian/analytics';

export function trackShowRatingsBlock(): void {
  ca('eventSite', {
    action: 'show_rating',
    category: 'Promo',
    name: 'oldevent',
    useLastProducts: true,
  });
}
